import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudSecurityGroup = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'security_group/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudAllSecurityGroup = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_security_group_list/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudSecurityGroup = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'security_group/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const changePrivateCloudSecurityGroup = (data, id) => {
  let url = privateCloudBaseUrl + 'security_group/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    needPrivateCloudProjectHeader: true,
    method: method
  })
}

export const deletePrivateCloudSecurityGroup = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'security_group/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'delete'
  })
}

export const syncPrivateCloudSecurityGroup = () => {
  return axios.request({
    url: privateCloudBaseUrl + 'sync_security_group/',
    method: 'post'
  })
}
